import { input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
export class AgentToolPermissionBoxComponent {
    constructor() {
        this.permissionText = input.required();
        this.confirm = output();
        this.alwaysApply = model(false);
    }
    authorize() {
        this.confirm.emit({
            authorize: true,
            alwaysApply: this.alwaysApply(),
        });
    }
    reject() {
        this.confirm.emit({
            authorize: false,
            alwaysApply: this.alwaysApply(),
        });
    }
}
AgentToolPermissionBoxComponent.ɵfac = function AgentToolPermissionBoxComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentToolPermissionBoxComponent)(); };
AgentToolPermissionBoxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentToolPermissionBoxComponent, selectors: [["ycn-agent-tool-permission-box"]], inputs: { permissionText: [1, "permissionText"], alwaysApply: [1, "alwaysApply"] }, outputs: { confirm: "confirm", alwaysApply: "alwaysApplyChange" }, decls: 18, vars: 2, consts: [[1, "pt-3", "pr-20", "pb-3", "pl-20", "bg-white", "rounded-4", "mt-20"], [1, "text-large", "leading-relaxed"], ["href", "/account-settings", 1, "text-underline-hover"], [1, "row", "mt-3", "mb-10"], [1, "col-6"], [1, "btn", "btn-secondary", "btn-block", 3, "click"], [1, "btn", "btn-primary", "btn-block", 3, "click"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"]], template: function AgentToolPermissionBoxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵelementStart(3, "a", 2);
        i0.ɵɵtext(4, "Account Settings");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(5, ". ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 3)(7, "div", 4)(8, "button", 5);
        i0.ɵɵlistener("click", function AgentToolPermissionBoxComponent_Template_button_click_8_listener() { return ctx.reject(); });
        i0.ɵɵtext(9, "Reject");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "div", 4)(11, "button", 6);
        i0.ɵɵlistener("click", function AgentToolPermissionBoxComponent_Template_button_click_11_listener() { return ctx.authorize(); });
        i0.ɵɵtext(12, "Allow");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(13, "label", 7)(14, "input", 8);
        i0.ɵɵtwoWayListener("ngModelChange", function AgentToolPermissionBoxComponent_Template_input_ngModelChange_14_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.alwaysApply, $event) || (ctx.alwaysApply = $event); return $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(15, "span", 9);
        i0.ɵɵelementStart(16, "span", 10);
        i0.ɵɵtext(17, "Always apply this answer");
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("Please confirm I have permission to ", ctx.permissionText(), " on your behalf. I will save your preference and you can always change it in your ");
        i0.ɵɵadvance(12);
        i0.ɵɵtwoWayProperty("ngModel", ctx.alwaysApply);
    } }, dependencies: [FormsModule, i1.CheckboxControlValueAccessor, i1.NgControlStatus, i1.NgModel], encapsulation: 2, changeDetection: 0 });
